<!--
 * @Description: 批改作业评定详情
 * @Author: Xyyyyyy
 * @Date: 2023-07-14 17:05:11
 * @LastEditors: PF
 * @LastEditTime: 2024-08-02 11:01:33
-->
<template>
    <div>
      <el-dialog class="w680 h680" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
        <template #header>
          <div class="header-left">
            <el-icon class="header-icon">
              <Document />
            </el-icon>
            <span class="header-title">详情</span>
          </div>
          <div class="header-right">
            <el-button type="info" text @click="closeWindow('openDetail', emits, true)">
              <el-icon>
                <Close />
              </el-icon>
            </el-button>
          </div>
        </template>
        <el-descriptions :column="4" border>
          <el-descriptions-item label="评分" label-align="right" align="left" width="120px" span="2">{{ruleForm.pf}}
          </el-descriptions-item>
          <el-descriptions-item label="等级" label-align="right" align="left" width="120px" span="2">
            <span v-for="(item, index) in pdgjData" :key="index">
              <span v-if="ruleForm.dj==item.value">{{item.name}}</span>
            </span>
          </el-descriptions-item>
          <el-descriptions-item label="是否已评价" label-align="right" align="left" width="120px" span="2">
            <span v-if="ruleForm.sfypj === true">已评价</span>
            <span v-if="ruleForm.sfypj === false">未评价</span>
          </el-descriptions-item>
          <el-descriptions-item label="评价人姓名" label-align="right" align="left" width="120px" span="2">{{ ruleForm.pjrxm }}</el-descriptions-item>
          <el-descriptions-item label="评价时间"  label-align="right" align="left" width="120px" span="2">{{ ruleForm.pjsj }}</el-descriptions-item>
          <el-descriptions-item label="班级名称"  label-align="right" align="left" width="120px" span="2">{{ ruleForm.bjmc }}</el-descriptions-item>
          <el-descriptions-item label="课程名称"  label-align="right" align="left" width="120px" span="4">{{ ruleForm.kcmc }}</el-descriptions-item>
          <el-descriptions-item label="综合评价" label-align="right" align="left" width="120px" span="4">{{ ruleForm.zhpj }}</el-descriptions-item>
        </el-descriptions>
        <template #footer>
          <div class="dialog-footer">
            <div></div>
            <div class="footer_but">
              <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
            </div>
          </div>
        </template>
      </el-dialog>
    </div>
  </template>
<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow, loadSelect } from '@/api/common.js'

// 弹窗
const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail'])

const ruleForm = ref({})

const pdgjData = ref({})// 评定等级
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadSelect({ url: '/api/v2/jiaowu/jiaoxuegongzuojiancha/pingjiadengji', data: pdgjData })
      loadData({
        url: 'api/v2/jiaowu/jiaoxuegongzuozuoyepigaijiancha/' + props.row.id,
        ruleForm
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
<style lang="less" scoped>
  :deep(.el-dialog__body) {
    overflow: visible;
    .paging {
      margin-top: 20px;
    }
  }
  </style>
